export enum ProductTypeEnum {
  Inventory = 'Inventory',
  NonInventory = 'NonInventory',
  Service = 'Service',
  CapitalEquipment = 'Capital Equipment',
  Vendor = 'Vendor',
}
